import { useQuery } from '@tanstack/react-query';
import { Contact } from '../../../types/Contact';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchContact = async (uuid: string) => {
  const response = await CustomAxios.get<Contact>(`contacts/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetContactByIdProps {
  uuid: string;
}
export function useGetContactById({ uuid }: UseGetContactByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allContacts, uuid],
    queryFn: () => fetchContact(uuid)
  });

  return query;
}
